export default __webpack_public_path__ + "static/media/53-bijou.8ad25cf4.jpg";